import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { columns } from "./columns";
import { useDealers } from "../hooks/useDealers";
import { CreateDealerFab } from "../create/CreateDealerFab";
import { useMemo } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Clear, Search } from "@mui/icons-material";
import { useSessionStorage } from "usehooks-ts";

export default function ListDealers() {
  const { setError } = useErrorMessage();
  const { dealers, loading, error } = useDealers();
  const [query, setQuery] = useSessionStorage("dealer_query", "");
  const filtered = useMemo(() => {
    const queryLower = query.toLowerCase();
    return !query
      ? dealers
      : dealers.filter(
          (s) =>
            s.dealerNumber?.toLowerCase().includes(queryLower) ||
            s.companyName?.toLowerCase().includes(queryLower) ||
            s.contactEmail?.toLowerCase().includes(queryLower)
        );
  }, [dealers, query]);
  if (error) {
    setError(error);
  }
  if (loading || !dealers) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <DataGridContainer>
      <OutlinedInput
        size="small"
        placeholder="Search"
        sx={{ position: "absolute", top: 80, right: 72 }}
        startAdornment={
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        }
        endAdornment={
          query ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => setQuery("")}
                sx={{ opacity: query ? 1 : 0 }}
                disabled={!query}
                edge="end"
              >
                <Clear />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      <DataGrid
        useSessionStorageForPagination
        id="dealers"
        columns={columns}
        rows={filtered}
        doubleClickSlug="dealers"
      />
      <CreateDealerFab />
    </DataGridContainer>
  );
}
